import { render, staticRenderFns } from "./Overflowed.vue?vue&type=template&id=07efd648&"
import script from "./Overflowed.vue?vue&type=script&lang=js&"
export * from "./Overflowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports